// ============================================================================
// RUSSIAN BIBLE PASSAGES - Synodal Translation
// ============================================================================
// Русские библейские отрывки со ссылками на Стронга

export const biblePassagesRu = {
  "Bytie_1": {
    book: "Бытие",
    chapter: 1,
    title: "Сотворение мира",
    verses: [
      { number: 1, text: "В начале сотворил Бог небо и землю.", strong: ["H7225", "H430", "H1254"] },
      { number: 2, text: "Земля же была безвидна и пуста, и тьма над бездною, и Дух Божий носился над водою.", strong: ["H776", "H8414", "H7307"] },
      { number: 3, text: "И сказал Бог: да будет свет. И стал свет.", strong: ["H430", "H559", "H216"] },
      { number: 4, text: "И увидел Бог свет, что он хорош, и отделил Бог свет от тьмы.", strong: ["H430", "H7200", "H216", "H2896"] },
      { number: 5, text: "И назвал Бог свет днем, а тьму ночью. И был вечер, и было утро: день один.", strong: ["H430", "H7121", "H3117", "H3915"] },
      { number: 6, text: "И сказал Бог: да будет твердь посреди воды, и да отделяет она воду от воды.", strong: ["H430", "H7549", "H4325"] },
      { number: 7, text: "И создал Бог твердь, и отделил воду, которая под твердью, от воды, которая над твердью. И стало так.", strong: ["H430", "H6213", "H7549"] },
      { number: 8, text: "И назвал Бог твердь небом. И был вечер, и было утро: день второй.", strong: ["H430", "H7121", "H8064"] },
      { number: 27, text: "И сотворил Бог человека по образу Своему, по образу Божию сотворил его; мужчину и женщину сотворил их.", strong: ["H430", "H1254", "H120", "H6754"] },
      { number: 31, text: "И увидел Бог все, что Он создал, и вот, хорошо весьма. И был вечер, и было утро: день шестой.", strong: ["H430", "H7200", "H2896", "H3966"] }
    ]
  },
  "Psalom_23": {
    book: "Псалтирь",
    chapter: 23,
    title: "Господь - Пастырь мой",
    verses: [
      { number: 1, text: "Господь - Пастырь мой; я ни в чем не буду нуждаться.", strong: ["H3068", "H7462", "H2637"] },
      { number: 2, text: "Он покоит меня на злачных пажитях и водит меня к водам тихим.", strong: ["H7257", "H4999", "H5148", "H4325"] },
      { number: 3, text: "Подкрепляет душу мою, направляет меня на стези правды ради имени Своего.", strong: ["H7725", "H5315", "H5148", "H6664"] },
      { number: 4, text: "Если я пойду и долиною смертной тени, не убоюсь зла, потому что Ты со мной; Твой жезл и Твой посох - они успокаивают меня.", strong: ["H1980", "H1516", "H6757", "H3372", "H7626"] },
      { number: 5, text: "Ты приготовил предо мною трапезу в виду врагов моих; умастил елеем голову мою; чаша моя преисполнена.", strong: ["H6186", "H7979", "H6887", "H1878", "H3563"] },
      { number: 6, text: "Так, благость и милость да сопровождают меня во все дни жизни моей, и я пребуду в доме Господнем многие дни.", strong: ["H2896", "H2617", "H7291", "H3117", "H1004", "H3068"] }
    ]
  },
  "Ioanna_3": {
    book: "Евангелие от Иоанна",
    chapter: 3,
    title: "Иисус и Никодим",
    verses: [
      { number: 16, text: "Ибо так возлюбил Бог мир, что отдал Сына Своего Единородного, дабы всякий верующий в Него, не погиб, но имел жизнь вечную.", strong: ["G2316", "G25", "G2889", "G1325", "G5207"] },
      { number: 17, text: "Ибо не послал Бог Сына Своего в мир, чтобы судить мир, но чтобы мир спасен был чрез Него.", strong: ["G2316", "G649", "G2889", "G2919", "G4982"] },
      { number: 18, text: "Верующий в Него не судится, а неверующий уже осужден, потому что не уверовал во имя Единородного Сына Божия.", strong: ["G4100", "G2919", "G3686", "G5207", "G2316"] }
    ]
  },
  "Filippijanam_4": {
    book: "К Филиппийцам",
    chapter: 4,
    title: "Мир Божий",
    verses: [
      { number: 4, text: "Радуйтесь всегда в Господе; и еще говорю: радуйтесь.", strong: ["G5463", "G2962", "G3825"] },
      { number: 6, text: "Не заботьтесь ни о чем, но всегда в молитве и прошении с благодарением открывайте свои желания пред Богом.", strong: ["G3309", "G4335", "G1162", "G2169"] },
      { number: 7, text: "И мир Божий, который превыше всякого ума, соблюдет сердца ваши и помышления ваши во Христе Иисусе.", strong: ["G1515", "G2316", "G5242", "G3563", "G5432"] },
      { number: 13, text: "Все могу в укрепляющем меня Иисусе Христе.", strong: ["G1411", "G1743", "G5547"] }
    ]
  }
};

export default biblePassagesRu;
